<template>
  <v-btn-toggle style="flex-direction: column; background-color: transparent;" class="new-toggle-button" dense mandatory color="#9B004B" v-model="status">
    <v-row>
      <div  class="toggle-button-div" v-for="value in valuesList" :key="value.status">
        <v-slide-x-reverse-transition leave-absolute>
          <v-btn class="ml-2 mdi-check-button" v-if="status === value.status" rounded :color=value.color>
            <v-icon  color="gray" size="24" >mdi-check</v-icon>
          </v-btn>
        </v-slide-x-reverse-transition>
          <transition name="slide-fade">
          </transition>
        <v-btn class="ml-2 pill-button"
              rounded
              active-class='active-pill-button'
              min-width="48px"
              :color=value.color
              :value=value.status
              @click="$emit('checked', value.status)" >
          <div class="button-content-rating">{{ value.label }}</div>
        </v-btn>
      </div>
    </v-row>

    <v-row class="space">
      <div  class="toggle-button-div" v-for="(rating, index) in ratingFiltersList" :key="rating.value">
        <v-slide-x-reverse-transition leave-absolute>
          <v-btn class="ml-2 mdi-check-button" v-if="status === rating.value" rounded>
            <v-icon  color="gray" size="24" >mdi-check</v-icon>
          </v-btn>
        </v-slide-x-reverse-transition>
        <transition name="slide-fade">
        </transition>
        <v-btn class="ml-2 pill-button"
              rounded
              active-class='active-pill-button'
              min-width="48px"
              :value=rating.value
              @click="$emit('checked', rating.value)" >
          <div class="button-content">
            <v-rating v-if="index < 5" :value=rating.value readonly color="#6e6e6e"></v-rating>
            <div v-else class="button-content-rating">{{ rating.value }}</div>
          </div>
        </v-btn>
      </div>
    </v-row>

  </v-btn-toggle>
</template>

<script>
  export default {
    name: "PillRadioButtons",
    props: {
      valuesList: {
        default: function() {return [
            {label: this.$t("feedback_page.pill.all"), status: 'all', color: '#999999'},
            {label: this.$t("feedback_page.pill.ratings"), status: 'ratings', color: '#d79bb8'},
            {label: this.$t("feedback_page.pill.comments"), color: '#b94e82'},
            {label: this.$t("feedback_page.pill.agreement"), status: 'agreement', color: '#ab2968'},
          ]
        },
        type: Array,
        required: false
      },
      ratingFiltersList: {
        default:  function() {return [
          {value: 5},
          {value: 4},
          {value: 3},
          {value: 2},
          {value: 1}
        ]
        }
      }
    },
    data() {
      return {
        status: 'alle'
      }
    }
  }
</script>

<style scoped>
.space {
  margin-top: 18.85px;
}
.toggle-button-div:hover, .toggle-button-div:focus {
  opacity: 0.8 !important;
  filter: brightness(90%);
}
.pill-button {
  height: 32px !important;
  border-radius: 30px !important;
  padding: 8px 16px !important;
  color: transparent !important;
  text-transform: capitalize !important;
}
.active-pill-button {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  margin-left: 1px !important;
  padding: 8px 16px 8px 8px !important;
}
.mdi-check-button {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  height: 32px !important;
  min-width: 32px !important;
  padding: 0px !important;
}
.button-content {
  color: white;
  letter-spacing: 0px;
  display:flex;
  justify-content:center;
  align-items:center;
  text-align: center;
}
.button-content-rating {
  color: #6e6e6e;
  letter-spacing: 0px;
}
.theme--light.v-btn {
  color: none !important;
}
</style>
